/**
 * MaxMarksValidator class is responsible for validating if the total marks in the model
 * do not exceed the maximum allowed marks as defined by the TaskInfoService.
 */
class MaxMarksValidator {
    /**
     * Constructor for MaxMarksValidator.
     * @param {Object} model - The model containing the marks to be validated.
     * @param {Object} $injector - AngularJS injector service for dependency injection.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;

        this._TaskInfoService = null;
        this._translate = null;

        // Initialize the error message using the translation service and TaskInfoService.
        this._message = this.$translate().instant('CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.MAX-MARKS', {
            'maxMarks': this.TaskInfoService().getTaskInfo().getTotalMarks()
        });
        this._forced_check = true;
    }

    /**
     * Get the TaskInfoService instance.
     * @returns {Object} TaskInfoService instance.
     */
    TaskInfoService() {
        if (!this._TaskInfoService) {
            this._TaskInfoService = this.$injector.get('TaskInfoService');
        }
        return this._TaskInfoService;
    }

    /**
     * Get the $translate service instance.
     * @returns {Object} $translate service instance.
     */
    $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validate the model's total marks against the maximum allowed marks.
     * @param {Object} from - The source object triggering the validation.
     * @returns {Object} Validation result object.
     */
    validate(from) {
        let result = {};
        let error = false;

        // Check if the model's total marks exceed the maximum allowed marks.
        if (this.TaskInfoService().getTaskInfo().getTotalMarks() !== 0 &&
            this.TaskInfoService().getTaskInfo().getTotalMarks() < this.model.getTotalMarks()) {
            error = true;
        }

        // Prepare the validation result.
        result = {
            'onSheetBlur': false,
            'onlyBanner': false,
            'validator': this.getValidatorName(),
            'modelUUID': this.model.getUUID(),
            'error': error,
            'status': error ? 'DANGER' : 'SUCCESS',
            'message': this._message,
            'message_template': false,
            'message_data': {
                'task_total_marks': this.TaskInfoService().getTaskInfo().getTotalMarks(),
                'total_marks': this.model.getTotalMarks()
            },
            'callbacks': []
        };

        return result;
    }

    /**
     * Get the error message.
     * @returns {string} Error message.
     */
    getErrorMessage() {
        return this._message;
    }

    /**
     * Check if the validation is forced.
     * @returns {boolean} True if the validation is forced, otherwise false.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Get the name of the validator.
     * @returns {string} Validator name.
     */
    getValidatorName() {
        return 'MaxMarksValidator';
    }
}

export default MaxMarksValidator;